import { logEvent } from './logGaEvent'
import { getDuplicatedFields } from './helpers/getDuplicatedFields'
import { getCabinClass, getAncillariesNode, replaceSpacesWithHyphens } from './helpers/listingsHelpers'
import { getEcommerceNode } from './logGaEvent-ecommerce'
import { toSnakeCase } from '@mfs/common/helpers/stringHelpers'
import { getBadgesString } from './logGaEvent-view-item-list'

/**
 * Trigger GA4 tag on listings item select.
 * @param {*} listingAttributes
 * @param {*} selectedIndex
 */
const logSelectItem = ({
  itinerary,
  searchRequestParams,
  airportCodeParams,
  searchEventData,
  tripType,
  hasRecommendedListings,
  isUserSignedIn,
  needsDelay,
}) => {
  if (searchEventData) {
    const itinAttributeForLog = {
      ...searchEventData,
    }
    itinAttributeForLog.ecommerce = {
      currency: 'usd',
      items: [
        ...getItem({
          itinerary,
          searchEventData,
          searchRequestParams,
          airportCodeParams,
          tripType,
          hasRecommendedListings,
          isUserSignedIn,
        }),
      ],
    }
    delete itinAttributeForLog?.priceKey
    logEvent('select_item', itinAttributeForLog, needsDelay)
  }
}

const getOriginLinkItem = ({ slice, tripType }) => {
  const origin = slice?.origin?.code
  const destination = slice?.destination?.code

  return toSnakeCase(`${tripType}_${origin}-${destination}`, { lowerCase: true })
}

export const logInternalLink = ({ itinerary }) => {
  logEvent('internal_link', {
    type: 'sopq',
    link_name: 'see_all_express_deals',
    link_item: getOriginLinkItem({ slice: itinerary?.slice?.[0], tripType: itinerary?.tripType }),
    page_name: 'listings',
    product_name: 'air',
  })
}

const getItem = ({
  itinerary,
  searchEventData,
  searchRequestParams,
  airportCodeParams,
  tripType,
  hasRecommendedListings,
  isUserSignedIn,
}) => {
  const { trip_end_city: tripEndCityName, ap, los, type } = searchEventData
  const { slices, isExpressDeal, allFareBrandNames, listingPosition, fareBrands, voidWindowInfo } = itinerary
  const { stops, timeFrame, connections, isCancellable, commonProps, upgrade_available, quantity } =
    getDuplicatedFields({
      slices,
      isExpressDeal,
      voidWindowInfo,
      allFareBrandNames,
      listingPosition,
      fareBrands,
      searchRequestParams,
    })
  const upgrade_content = fareBrands?.length > 1 ? 'fare_brand' : null
  const arr = []
  if (fareBrands?.length > 0) {
    const visibleFareBrands = fareBrands?.slice(0, 2)
    const cabinClass = getCabinClass(visibleFareBrands)
    const fb = visibleFareBrands?.[0]
    commonProps.price = fb?.price?.find((p) => p?.type === 'TOTAL_PRICE')?.amount
    commonProps.cabin_class = replaceSpacesWithHyphens(cabinClass)
    const ancillary = getAncillariesNode(fb?.ancillaries)

    const { priceKey = '' } = itinerary
    const finalClass = toSnakeCase(fareBrands.find((fb) => fb?.priceKey === priceKey)?.name, {
      lowerCase: true,
    }) // selected farebrand

    const allBadgesString = getBadgesString({
      slices,
      isExpressDeal,
      listingPosition,
      hasRecommendedListings,
    })

    const segments = slices?.[0]?.segments || []

    arr.push({
      ...getEcommerceNode({
        isUserSignedIn,
        tripEndCityName,
        ap,
        los,
        segments,
        connections,
        type,
        isExpressDeal,
        airportCodeParams,
        isCheapest: slices?.[0]?.merchandisingBadges?.some(
          (badge) => badge?.title?.toLowerCase() === 'cheapest'
        ),
        tripType,
        stops,
        timeFrame,
        allBadgesString,
      }),
      quantity,
      connections,
      ancillary,
      upgrade_available,
      upgrade_content,
      cancellation_flag: isCancellable ? 'y' : 'n',
      ...commonProps,
      final_class: finalClass,
      isUserSignedIn,
    })
  }

  return arr
}

export { logSelectItem }
